import Layout from './Layout'

export default Layout



// WEBPACK FOOTER //
// ./src/features/OrderDetails/components/Layout/index.js